(function ($) {
  $(document).ready(function () {
    if ($(".search-slider").length > 1) {
      $(".search-slider").each(function () {
        if ($(this).find(".two-col").length > 2) {
          $(".search-slider .column-wrapper").slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: false,
            cssEase: "linear",
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          });
        }
      });
    } else {
      if ($(".search-slider").length > 0) {
        if ($(".search-slider .column-wrapper .two-col").length > 2) {
          $(".search-slider .column-wrapper").slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: false,
            cssEase: "linear",
            responsive: [
              {
                breakpoint: 991,
                settings: {
                  slidesToShow: 1,
                },
              },
            ],
          });
        }
      }
    }
  });
})(jQuery);
